import { render, staticRenderFns } from "./FooterBottom.vue?vue&type=template&id=2f71c532"
import script from "./FooterBottom.vue?vue&type=script&lang=js"
export * from "./FooterBottom.vue?vue&type=script&lang=js"
import style0 from "./FooterBottom.vue?vue&type=style&index=0&id=2f71c532&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports